import helpers from '#app#/global/helpers.js'
import blazy from '#app#/global/blazy.js'

export default {
    Vue: null,

    install(Vue, options) {
        this.Vue = Vue;

        // Install global variables
        // Available as global and instance properties
        this.setGlobal('helpers', helpers);
        this.setGlobal('user', window.FRONTEND_USER);
        this.setGlobal('blazy', blazy);
        this.setGlobal('pageTransitionDuration', 500);
    },

    setGlobal(name, val) {
        this.Vue[name] = val;
        this.Vue.prototype[`$${name}`] = val;
    }
}


// WEBPACK FOOTER //
// ../default-js/js/plugins/AppGlobals.js